import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../../../form/component/Checkbox'
import { WIDGET_LIST } from '../../../../constant/widgets'


const WidgetAdmin = ({ currentUser, toggleWidgetAccess, saveUser }) => {
    const widgetList = WIDGET_LIST
    return (
        <div>
            Widget access<br/>
            {
                Object.entries(widgetList).map(([widgetId, widgetName]) => {
                    const hasWidgetAccess = currentUser.visibleWidgetList.indexOf(widgetId) !== -1
                    return (
                        <Checkbox
                            key={widgetId}
                            object={{ hasWidgetAccess }}
                            onChange={() => {
                                toggleWidgetAccess(widgetId, !hasWidgetAccess)
                                saveUser()
                            }}
                            name="hasWidgetAccess">{widgetName}
                        </Checkbox>)
                })
            }
        </div>)
}


WidgetAdmin.propTypes = {
    currentUser: PropTypes.object,
    toggleWidgetAccess: PropTypes.func.isRequired,
    saveUser: PropTypes.func.isRequired,
}

export default WidgetAdmin




// WEBPACK FOOTER //
// ./src/modules/security/component/manage/WidgetAdmin.js